import { Chip, Switch, Tooltip } from "@heroui/react";
import { useLab } from "../lib/state.tsx";

export function Header() {
  const { modes, connected, setMode } = useLab();
  const scripted = modes ? !modes.live : true;

  return (
    <header className="flex flex-wrap items-center gap-3 border-b border-default-100/60 px-4 py-3">
      <div className="flex items-baseline gap-2">
        <span className="text-lg font-semibold tracking-tight">MCP Lab</span>
        <span className="font-mono text-xs text-default-500">v{modes?.version ?? "—"}</span>
      </div>

      <Chip
        size="sm"
        variant="flat"
        color={scripted ? "warning" : "success"}
        className="font-mono"
      >
        {scripted ? "SCRIPTED" : "LIVE"}
      </Chip>

      <Tooltip
        content={
          scripted
            ? "The model's choices come from a canned transcript. Every tool call still executes for real against the MCP server, and every token number is measured from the actual bytes."
            : `A real model (${modes?.model}) is choosing the tool calls.`
        }
        className="max-w-xs"
      >
        <span className="cursor-help text-xs text-default-500 underline decoration-dotted">
          what does that mean?
        </span>
      </Tooltip>

      <div className="ml-auto flex items-center gap-4">
        {modes?.hasModelAccess && (
          <Switch
            size="sm"
            isSelected={modes.modes.scripted}
            onValueChange={(v) => void setMode("scripted", v)}
          >
            <span className="text-xs">Force scripted</span>
          </Switch>
        )}

        {!modes?.attacksEnabled && (
          <Chip size="sm" color="default" variant="bordered" className="font-mono">
            attacks disabled
          </Chip>
        )}

        <span className="flex items-center gap-2 text-xs text-default-500">
          <span
            className={`inline-block h-2 w-2 rounded-full ${connected ? "bg-success" : "bg-danger"}`}
          />
          {connected ? "wire connected" : "wire offline"}
        </span>
      </div>
    </header>
  );
}
